import { curry, compose, subtract, indexOf, add, not } from 'ramda';
import { Rank, File } from '../presets/terms.js';
import '../presets/rules.js';

function detectDarkTile(r,e){if(!r||!e)throw new TypeError("invalid arguments");var t=compose(Math.abs,subtract(8),indexOf(e))(Rank),a=compose(add(1),indexOf(r))(File);return not(1&add(t,a))}var detectDarkTile$1 = curry(detectDarkTile);

export { detectDarkTile$1 as default };
//# sourceMappingURL=detectDarkTile.js.map
